import type { ReactNode } from 'react';

import useModalImpression from '~/hooks/useModalImpression';
import type { ModalScreen } from '~/utils/modalProperties';

type Props = {
  children: ReactNode;
  className?: string;
  screen: ModalScreen;
};

// Rendered inside the dialog, not around it: the dialog mounts its content through a portal after
// its parent's effects have run, so an impression observed from the parent finds no element.
export default function ModalScreenImpression({
  children,
  className,
  screen
}: Props) {
  const ref = useModalImpression<HTMLDivElement>(screen);

  return (
    <div className={className} ref={ref}>
      {children}
    </div>
  );
}
